import { RequestModelInterface } from "@/service/models/request-model-interface";
import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { FormulationAndRouteEnums } from "../../parts/formulation-and-route-enums";

@staticImplements<ResponseModelInterfaceStatic>()
export class FormulationAndRoute implements RequestModelInterface
{
    public constructor(
        public formulation: string,
        public administrationName: string,
        public administrationRoute: FormulationAndRouteEnums.AdministrationRoute,
        public absorptionModel: FormulationAndRouteEnums.AbsorptionModelComputation,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): FormulationAndRoute
    {
        return new this(
            elem.firstChildByTag("formulation").value(),
            elem.firstChildByTag("administrationName").value(),
            elem.firstChildByTag("administrationRoute").enumValue(FormulationAndRouteEnums.AdministrationRoute),
            elem.firstChildByTag("absorptionModel").enumValue(FormulationAndRouteEnums.AbsorptionModelComputation),
        );
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("formulationAndRoute");

        element.appendNewElement("formulation", this.formulation);
        element.appendNewElement("administrationName", this.administrationName);
        element.appendNewElement("administrationRoute", this.administrationRoute);
        element.appendNewElement("absorptionModel", this.absorptionModel);

        return element;
    }
}
